import React, { useEffect, useState } from 'react';
import {
	Box,
	Container,
	Grid,
	makeStyles,
	Avatar,
	Chip,
	Accordion,
	AccordionSummary,
	AccordionDetails,
	Slider,
	withStyles,
	FormControlLabel,
	Checkbox,
	Hidden,
	useMediaQuery,
	useTheme,
} from '@material-ui/core';
import Skeleton from '@material-ui/lab/Skeleton';
import PermIdentityIcon from '@material-ui/icons/PermIdentity';
import LocalPhoneIcon from '@material-ui/icons/LocalPhone';
import musafirbazarlogo from '../../assets/images/musafirbazarlogo.png';
import FormatAlignLeftIcon from '@material-ui/icons/FormatAlignLeft';
import TitleText from '../../components/reusableComponents/TitleText';
import BodyText from '../../components/reusableComponents/BodyText';
import flightpro from '../../assets/images/flightpro.png';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import CardFlight from '../../components/reusableComponents/CardFlight';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import InfiniteScroll from 'react-infinite-scroll-component';
import FlightDetailModal from '../../components/reusableComponents/FlightDetailModal';
import Home from '../../assets/images/home_hero_bg.jpg';
import {
	setFilterData,
	setFlightId,
	toggleFlightModal,
} from '../../reducers/UiReducer';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { useDispatch, useSelector } from 'react-redux';
import WbSunnyIcon from '@material-ui/icons/WbSunny';
import { useHistory, useLocation } from 'react-router-dom';
import { SearchFormDispatch } from '../../reducers/HomeReducer';
import Header from '../../components/reusableComponents/Header';
import Drawers from '../../components/Drawers';
import Login from '../../components/reusableComponents/Login';
import InternalSearchForm from '../../components/reusableComponents/InternalSearchForm';
import NonLinearSlider from '../../components/reusableComponents/NonLinearSlider';

const useStyles = makeStyles((theme) => ({
	root: {
		'& .MuiChip-sizeSmall': {
			height: 36,
		},
	},
	accodin: {
		'& .MuiAccordionSummary-content': {
			justifyContent: 'space-between',
		},
	},
	searhform: {
		backgroundImage: `url(${Home})`,
		height: 272,
		// height: 200,
		backgroundSize: 'cover',
		backgroundRepeat: 'no-repeat',

		paddingTop: 124,
		// position: 'relative',
		// [theme.breakpoints.up('lg')]: {
		// 	height: 494,
		// },
		[theme.breakpoints.down('xs')]: {
			height: 590,
		},
	},
}));

const GreenCheckbox = withStyles({
	root: {
		color: '#39c9bb',
		'&$checked': {
			color: '#39c9bb',
		},
	},
	checked: {},
})((props) => <Checkbox color='default' {...props} />);
const Flight = () => {
	const classes = useStyles();
	const dispatch = useDispatch();
	const [expanded, setExpanded] = React.useState('');
	const [check, setCheck] = useState(false);
	const [check2, setCheck2] = useState(false);
	const [check3, setCheck3] = useState(false);
	const [check4, setCheck4] = useState(false);
	const [check5, setCheck5] = useState(false);
	const [scrollVal, SetScrollVal] = useState(10);
	const [scrollValResult, SetScrollValResult] = useState(10);
	const [hasMoreresult, SethasMoreResult] = useState(true);
	const [hasMorefilterData, SethasMoreFilterData] = useState(true);
	const [result, setResult] = useState([]);
	const history = useHistory();
	const theme = useTheme();
	const location = useLocation();
	const { search, loading } = useSelector((state) => state.home);
	const { filterDataR } = useSelector((state) => state.ui);
	const [stop1, setStop1] = useState(false);
	const [value, setValue] = React.useState([1000, 5000]);

	const [stop2, setStop2] = useState(false);
	const [stop3, setStop3] = useState(false);
	const [morning, setMorning] = useState(false);
	const [dophar, setDOphar] = useState(false);
	const matches = useMediaQuery(theme.breakpoints.down('sm'));
	const matches2 = useMediaQuery(theme.breakpoints.down('xs'));
	const handleSlider = (event, newValue) => {
		setValue(newValue);
		console.log(newValue);
		let checkData = [];
		if (search && newValue) {
			search &&
				search.data &&
				search.data.Response &&
				search.data.Response.Results[0].length > 0 &&
				search.data.Response.Results[0].map((item) => {
					let a = item.Fare.BaseFare;
					let b = newValue[0];
					let c = newValue[1];
					if (a >= b && a <= c) {
						checkData.push({
							...item,
						});
					}
					// item.Segments[0].map((i) => {
					// 	if (i.Airline.AirlineName === event.target.name) {
					// 		checkData.push({
					// 			...item,
					// 		});
					// 	}
					// });
				});
		}
		// if () {
		// 	setResult([]);
		// 	SetScrollVal(10);
		// 	SetScrollValResult(10);
		// } else {
		// 	setResult(...result, checkData);
		// }

		setResult(checkData);
		SetScrollValResult(10);
		console.log('Slider Value', checkData);
	};
	const handleCheck = (event) => {
		setCheck(event.target.checked);
		console.log(event.target.name);
		let checkData = [];
		if (search && event.target.name) {
			search &&
				search.data &&
				search.data.Response &&
				search.data.Response.Results[0].length > 0 &&
				search.data.Response.Results[0].map((item) => {
					item.Segments[0].map((i) => {
						if (i.Airline.AirlineName === event.target.name) {
							checkData.push({
								...item,
							});
						}
					});
				});
		}
		console.log(checkData);
		if (check) {
			setResult([]);
			SetScrollVal(10);
			SetScrollValResult(10);
		} else {
			setResult(...result, checkData);
		}
	};
	const handleCheckGO = (event) => {
		setCheck2(event.target.checked);
		console.log(event.target.name);
		let checkData = [];
		if (search && event.target.name) {
			search &&
				search.data &&
				search.data.Response &&
				search.data.Response.Results[0].length > 0 &&
				search.data.Response.Results[0].map((item) => {
					item.Segments[0].map((i) => {
						if (i.Airline.AirlineName === event.target.name) {
							checkData.push({
								...item,
							});
						}
					});
				});
		}
		console.log(checkData);
		if (check2) {
			setResult([]);
			SetScrollVal(10);
			SetScrollValResult(10);
		} else {
			setResult(...result, checkData);
		}
	};
	const handleCheckIndigo = (event) => {
		setCheck3(event.target.checked);
		console.log(event.target.name);
		let checkData = [];
		if (search && event.target.name) {
			search &&
				search.data &&
				search.data.Response &&
				search.data.Response.Results[0].length > 0 &&
				search.data.Response.Results[0].map((item) => {
					item.Segments[0].map((i) => {
						if (i.Airline.AirlineName === event.target.name) {
							checkData.push({
								...item,
							});
						}
					});
				});
		}
		console.log(checkData);
		if (check3) {
			setResult([]);
			SetScrollVal(10);
			SetScrollValResult(10);
		} else {
			setResult(...result, checkData);
		}
	};
	const handleCheckAir = (event) => {
		setCheck4(event.target.checked);
		console.log(event.target.name);
		let checkData = [];
		if (search && event.target.name) {
			search &&
				search.data &&
				search.data.Response &&
				search.data.Response.Results[0].length > 0 &&
				search.data.Response.Results[0].map((item) => {
					item.Segments[0].map((i) => {
						if (i.Airline.AirlineName === event.target.name) {
							checkData.push({
								...item,
							});
						}
					});
				});
		}
		console.log(checkData);
		if (check4) {
			setResult([]);
			SetScrollVal(10);
			SetScrollValResult(10);
		} else {
			setResult(...result, checkData);
		}
	};
	const handleCheckVistara = (event) => {
		setCheck5(event.target.checked);
		console.log(event.target.name);
		let checkData = [];
		if (search && event.target.name) {
			search &&
				search.data &&
				search.data.Response &&
				search.data.Response.Results[0].length > 0 &&
				search.data.Response.Results[0].map((item) => {
					item.Segments[0].map((i) => {
						if (i.Airline.AirlineName === event.target.name) {
							checkData.push({
								...item,
							});
						}
					});
				});
		}
		console.log(checkData);
		if (check5) {
			setResult([]);
			SetScrollVal(10);
			SetScrollValResult(10);
		} else {
			setResult(...result, checkData);
		}
	};
	const handleChange = (panel) => (event, newExpanded) => {
		setExpanded(newExpanded ? panel : false);
	};

	function valuetext(value) {
		return `${value}°C`;
	}
	function display(a) {
		var hours = Math.trunc(a / 60);
		var minutes = a % 60;
		console.log(hours + ':' + minutes);
	}
	function timeConvert(n) {
		var num = n;
		var hours = num / 60;
		var rhours = Math.floor(hours);
		var minutes = (hours - rhours) * 60;
		var rminutes = Math.round(minutes);
		return rhours + ' hr and ' + rminutes + ' min.';
	}
	console.log(location.state);
	let filterData = [];
	filterData =
		search &&
		search.data &&
		search.data.Response &&
		search.data.Response.Results[0].length > 0 &&
		search.data.Response.Results[0].slice().sort((a, b) => {
			return a.Fare.BaseFare - b.Fare.BaseFare;
		});
	console.log('fILTER', filterData);
	// let appnt = [];
	// if (search && patients && doctor) {
	// 	appointments.map((app) => {
	// 		return patients.map((pat) => {
	// 			return doctor.doctor.forEach((doc) => {
	// 				if (app.patient === pat.id && app.assigned_nurse === doc.id) {
	// 					appnt.push({
	// 						...app,
	// 						patient: pat,
	// 						nurse: doc,
	// 					});
	// 				}
	// 			});
	// 		});
	// 	});
	// }
	// if (filterData && filterData.length > 0) {
	// 	dispatch(
	// 	setFilterData(filterData && filterData.length > 0 ? filterData : '')
	// );
	// }
	// const handleScroll = (e) => {
	// 	if (
	// 		window.innerHeight + e.target.documentElement.scrollTop + 1 >=
	// 		e.target.documentElement.scrollHeight
	// 	) {
	// 		console.log("Scroll")
	// 	}
	// };
	const fetchMoreData = () => {
		if (scrollVal >= filterData.length) {
			SethasMoreFilterData(false);
		}
		// a fake async api call like which sends
		// 20 more records in .5 secs
		setTimeout(() => {
			SetScrollVal(scrollVal + 5);
			// this.setState({
			// 	items: this.state.items.concat(Array.from({ length: 20 })),
			// });
		}, 500);
	};
	const fetchMoreDataResult = () => {
		if (scrollValResult >= filterData.length) {
			SethasMoreResult(false);
		}
		// a fake async api call like which sends
		// 20 more records in .5 secs
		setTimeout(() => {
			SetScrollValResult(scrollValResult + 5);
			// this.setState({
			// 	items: this.state.items.concat(Array.from({ length: 20 })),
			// });
		}, 500);
	};
	useEffect(() => {
		if (location.state) {
			dispatch(SearchFormDispatch(location.state.body, history));
		}
	}, [dispatch]);
	// useEffect(() => {
	// 	window.addEventListener('scroll', handleScroll);
	// }, []);
	// console.log(result);
	const handleOne = () => {
		let checkData = [];
		if (search) {
			search &&
				search.data &&
				search.data.Response &&
				search.data.Response.Results[0].length > 0 &&
				search.data.Response.Results[0].map((item) => {
					if (item.Segments[0].length === 1) {
						checkData.push({
							...item,
						});
					}
					// item.Segments[0].map((i) => {
					// 	if (i.Airline.AirlineName === event.target.name) {
					// 		checkData.push({
					// 			...item,
					// 		});
					// 	}
					// });
				});
		}
		console.log(checkData);
		if (stop1) {
			setResult([]);
			SetScrollVal(10);
			SetScrollValResult(10);
		} else {
			setResult(checkData);
		}

		// if (check3) {
		// 	setResult('');
		// } else {
		// 	setResult(checkData);
		// }
	};
	const handleTwo = () => {
		let checkData = [];
		if (search) {
			search &&
				search.data &&
				search.data.Response &&
				search.data.Response.Results[0].length > 0 &&
				search.data.Response.Results[0].map((item) => {
					if (item.Segments[0].length === 2) {
						checkData.push({
							...item,
						});
					}
					// item.Segments[0].map((i) => {
					// 	if (i.Airline.AirlineName === event.target.name) {
					// 		checkData.push({
					// 			...item,
					// 		});
					// 	}
					// });
				});
		}
		console.log(checkData);
		setResult(checkData);
		if (stop2) {
			setResult([]);
			SetScrollVal(10);
			SetScrollValResult(10);
		} else {
			setResult(checkData);
		}
		// if (check3) {
		// 	setResult('');
		// } else {
		// 	setResult(checkData);
		// }
	};
	const handleThree = () => {
		let checkData = [];
		if (search) {
			search &&
				search.data &&
				search.data.Response &&
				search.data.Response.Results[0].length > 0 &&
				search.data.Response.Results[0].map((item) => {
					if (item.Segments[0].length === 3) {
						checkData.push({
							...item,
						});
					}
					// item.Segments[0].map((i) => {
					// 	if (i.Airline.AirlineName === event.target.name) {
					// 		checkData.push({
					// 			...item,
					// 		});
					// 	}
					// });
				});
		}
		console.log(checkData);
		setResult(checkData);
		if (stop3) {
			setResult([]);
			SetScrollVal(10);
			SetScrollValResult(10);
		} else {
			setResult(checkData);
		}
		// if (check3) {
		// 	setResult('');
		// } else {
		// 	setResult(checkData);
		// }
	};
	const handlemorning = () => {
		let checkData = [];
		if (search) {
			search &&
				search.data &&
				search.data.Response &&
				search.data.Response.Results[0].length > 0 &&
				search.data.Response.Results[0].map((item) => {
					console.log(
						item.Segments[0].slice(0, 1).map((i) => {
							return i.Origin.DepTime.substr(11, 2);
						})
					);
					console.log(
						'Dept',
						item.Segments[0].slice(0, 1).map((i) => {
							return i.Destination.ArrTime.substr(11, 2);
						})
					);
					let a = item.Segments[0].slice(0, 1).map((i) => {
						return i.Origin.DepTime.substr(11, 2);
					});
					let b = item.Segments[0].slice(0, 1).map((i) => {
						return i.Destination.ArrTime.substr(11, 2);
					});
					if (a >= 5 && b <= 12) {
						checkData.push({
							...item,
						});
					}
				});
		}
		if (morning) {
			setResult([]);
			SetScrollVal(10);
			SetScrollValResult(10);
		} else {
			setResult(checkData);
		}
		console.log('Morning', checkData);
	};
	const handledophar = () => {
		let checkData = [];
		if (search) {
			search &&
				search.data &&
				search.data.Response &&
				search.data.Response.Results[0].length > 0 &&
				search.data.Response.Results[0].map((item) => {
					console.log(
						item.Segments[0].slice(0, 1).map((i) => {
							return i.Origin.DepTime.substr(11, 2);
						})
					);
					console.log(
						'Dept',
						item.Segments[0].slice(0, 1).map((i) => {
							return i.Destination.ArrTime.substr(11, 2);
						})
					);
					let a = item.Segments[0].slice(0, 1).map((i) => {
						return i.Origin.DepTime.substr(11, 2);
					});
					let b = item.Segments[0].slice(0, 1).map((i) => {
						return i.Destination.ArrTime.substr(11, 2);
					});
					if (a >= 12 && b <= 18) {
						checkData.push({
							...item,
						});
					}
				});
		}
		if (dophar) {
			setResult([]);
			SetScrollVal(10);
			SetScrollValResult(10);
		} else {
			setResult(checkData);
		}
		console.log('Dophar', checkData);
	};

	console.log(location.state);
	console.log(result);
	console.log(scrollVal);
	return (
		<>
			<Box
				style={{
					paddingTop: '10px',
					background: 'white',
					position: 'absolute',
					zIndex: 99,
					height: 60,
					top: 0,
					right: 0,
					bottom: 0,
					left: 0,
				}}>
				<Container>
					<Header />
				</Container>
			</Box>
			<Box
				style={{
					backgroundColor: '#515b62',
					marginTop: 75,
					color: 'white',
					padding: 5,
				}}>
				<Container>
					<Box display='flex'>
						<TitleText
							two
							textStyle={{
								fontFamily: 'Josefin Sans, sans-serif',
								fontWeight: 500,
							}}>
							MusafirBazar Holiday /
						</TitleText>
						<TitleText
							two
							textStyle={{
								marginLeft: 5,
								fontFamily: 'Josefin Sans, sans-serif',
								fontWeight: 500,
							}}>
							Flight /
						</TitleText>
					</Box>
				</Container>
			</Box>
			<Box
				className={classes.searhform}
				style={{ backgroundPosition: matches2 ? '' : '1px -443px' }}>
				<Container>
					<InternalSearchForm />
				</Container>
			</Box>
			<Box mt={'35px'}>
				<Container>
					<Box
						style={{
							textAlign: 'justify',
							border: '1px solid #d7d7d7',
							padding: 10,
							background: 'white',
						}}>
						<BodyText
							textStyle={{
								color: 'red',
								fontFamily: 'Josefin Sans, sans-serif',
								fontWeight: 500,
							}}>
							Important Information
						</BodyText>
						{/* textStyle={{ fontFamily: 'Roboto Serif, sans-serif' }} */}
						{/* <BodyText
							textStyle={{
								color: 'red',
								fontFamily: 'Roboto Serif, sans-serif',
							}}>
							You are advised to check official websites of relevant airlines,
							authorities and local government agencies for the latest
							Developments on travel restrictions. Do adjust your travel plans
							based on the latest information provided. You are advised to check
							at your Origin & Destination to ensure that your travel is not
							affected prior to commencement of journey. Mandatory health
							declaration and web check-in online 48 hours to 120 min before
							flight departure.
						</BodyText> */}
					</Box>
					<Box className={classes.accodin}>
						<Accordion
							square
							expanded={expanded === 'panel1'}
							onChange={handleChange('panel1')}>
							<AccordionSummary
								aria-controls='panel1d-content'
								id='panel1d-header'>
								<Box alignItems='center'>
									{/* <i class='fas fa-user'></i> */}
									<i class='fa-solid fa-filter'></i>
								</Box>
								<Hidden only={['xs']}>
									<Box display='flex' alignItems='center'>
										<TitleText
											two={matches ? false : true}
											one={matches ? true : false}
											textStyle={{
												fontFamily: 'Josefin Sans, sans-serif',
												fontWeight: 500,
											}}>
											STOPS
										</TitleText>
										<ExpandMoreIcon />
									</Box>
									<Box display='flex' alignItems='center'>
										<TitleText
											two={matches ? false : true}
											one={matches ? true : false}
											textStyle={{
												fontFamily: 'Josefin Sans, sans-serif',
												fontWeight: 500,
											}}>
											PRICE
										</TitleText>
										<ExpandMoreIcon />
									</Box>
									<Box display='flex' alignItems='center'>
										<TitleText
											two={matches ? false : true}
											one={matches ? true : false}
											textStyle={{
												fontFamily: 'Josefin Sans, sans-serif',
												fontWeight: 500,
											}}>
											AIRLINE
										</TitleText>
										<ExpandMoreIcon />
									</Box>
									<Box display='flex' alignItems='center'>
										<TitleText
											two={matches ? false : true}
											one={matches ? true : false}
											textStyle={{
												fontFamily: 'Josefin Sans, sans-serif',
												fontWeight: 500,
											}}>
											DEPARTURE TIME
										</TitleText>
										<ExpandMoreIcon />
									</Box>
								</Hidden>
								<Box display='flex' alignItems='center'>
									<TitleText
										two={matches ? false : true}
										one={matches ? true : false}
										textStyle={{
											fontFamily: 'Josefin Sans, sans-serif',
											fontWeight: 500,
										}}>
										RESET ALL
									</TitleText>
								</Box>
							</AccordionSummary>
							<AccordionDetails>
								<Grid container>
									<Grid item xs={12} lg={3}>
										<Box
											display={'flex'}
											style={{ padding: 10, marginLeft: 50 }}>
											<Box
												onClick={() => {
													handleOne();
													stop1 ? setStop1(false) : setStop1(true);
												}}
												style={{
													width: '40px',
													padding: '6px 0px',
													background: stop1 ? 'rgb(57, 201, 187)' : '#eee',
													color: stop1 ? 'white' : '#666',
													border: '1px solid #ddd',
													borderRadius: '2px',
													fontWeight: 700,
													textAlign: 'center',
													cursor: 'pointer',
												}}>
												<BodyText>0</BodyText>
											</Box>
											<Box
												onClick={() => {
													handleTwo();
													stop2 ? setStop2(false) : setStop2(true);
												}}
												style={{
													width: '40px',
													padding: '6px 0px',
													background: stop2 ? 'rgb(57, 201, 187)' : '#eee',
													color: stop2 ? 'white' : '#666',
													border: '1px solid #ddd',
													borderRadius: '2px',
													fontWeight: 700,
													textAlign: 'center',
													marginLeft: 10,
													cursor: 'pointer',
												}}>
												<BodyText>1</BodyText>
											</Box>
											<Box
												onClick={() => {
													handleThree();
													stop3 ? setStop3(false) : setStop3(true);
												}}
												style={{
													width: '40px',
													padding: '6px 0px',
													background: stop3 ? 'rgb(57, 201, 187)' : '#eee',
													color: stop3 ? 'white' : '#666',
													border: '1px solid #ddd',
													borderRadius: '2px',
													fontWeight: 700,
													textAlign: 'center',
													marginLeft: 10,
													cursor: 'pointer',
												}}>
												<BodyText>2</BodyText>
											</Box>
										</Box>
									</Grid>
									<Grid item xs={12} lg={3}>
										{/* <Box display='flex'> */}
										<Box
											style={
												{
													// maxWidth: 300,
													// display: 'flex',
												}
											}>
											{/* <Slider
												getAriaLabel={() => 'Temperature range'}
												value={value}
												onChange={handleRange}
												valueLabelDisplay='auto'
												getAriaValueText={valuetext}
											/> */}
											<Slider
												style={{ maxWidth: 500 }}
												value={value}
												min={1000}
												// step={1}
												max={10000}
												aria-label='Default'
												// valueLabelFormat={numFormatter}
												// marks={followersMarks}
												// scale={scaleValues}
												onChange={handleSlider}
												valueLabelDisplay='auto'
												aria-labelledby='non-linear-slider'
											/>
											<Box display='flex' justifyContent='space-between'>
												<BodyText>Min: {value[0]}</BodyText>
												<BodyText>Max: {value[1]}</BodyText>
											</Box>
										</Box>
										{/* </Box> */}

										{/* </Box> */}
									</Grid>
									<Grid item xs={12} lg={3}>
										<Box ml={'20px'} mt={matches ? '20px' : ''}>
											<FormControlLabel
												control={
													<GreenCheckbox
														checked={check}
														onChange={handleCheck}
														name='SpiceJet'
													/>
												}
												label='SpiceJet'
											/>
											<br />
											<FormControlLabel
												control={
													<GreenCheckbox
														checked={check2}
														onChange={handleCheckGO}
														name='GO FIRST'
													/>
												}
												label='GO FIRST'
											/>
											<br />
											<FormControlLabel
												control={
													<GreenCheckbox
														checked={check3}
														onChange={handleCheckIndigo}
														name='Indigo'
													/>
												}
												label='Indigo'
											/>
											<br />
											<FormControlLabel
												control={
													<GreenCheckbox
														checked={check4}
														onChange={handleCheckAir}
														name='Air Asia'
													/>
												}
												label='Air Asia'
											/>
											<br />
											<FormControlLabel
												control={
													<GreenCheckbox
														checked={check5}
														onChange={handleCheckVistara}
														name='Vistara'
													/>
												}
												label='Vistara'
											/>
											<br />
											{/* - */}
										</Box>
									</Grid>
									<Grid item xs={12} lg={3}>
										<Box display='flex' mt={matches ? '20px' : ''}>
											<Box
												onClick={() => {
													handlemorning();
													morning ? setMorning(false) : setMorning(true);
												}}
												style={{
													display: 'block',
													padding: '6px 10px',
													textAlign: 'center',
													// font-size: var(--fnt-12);
													// color: var(--gray);
													background: morning ? 'rgb(57, 201, 187)' : '#8f8f8f',
													color: morning ? 'white' : '',
													borderRight: '1px solid #ddd',
													fontWeight: 700,
													cursor: 'pointer',
													// background: '#8f8f8f',
												}}>
												<WbSunnyIcon />
												<Box>
													<BodyText one textStyle={{ color: 'white' }}>
														05-12
													</BodyText>
												</Box>
											</Box>
											<Box
												onClick={() => {
													handledophar();
													dophar ? setDOphar(false) : setDOphar(true);
												}}
												ml={'10px'}
												style={{
													display: 'block',
													padding: '6px 10px',
													textAlign: 'center',
													// font-size: var(--fnt-12);
													// color: var(--gray);
													borderRight: '1px solid #ddd',
													fontWeight: 700,
													cursor: 'pointer',
													background: dophar ? 'rgb(57, 201, 187)' : '#8f8f8f',
													color: dophar ? 'white' : '',
												}}>
												<WbSunnyIcon />
												<Box>
													<BodyText one textStyle={{ color: 'white' }}>
														12-18
													</BodyText>
												</Box>
											</Box>
											{/* <Box
												ml={'10px'}
												style={{
													display: 'block',
													padding: '6px 10px',
													textAlign: 'center',
													// font-size: var(--fnt-12);
													// color: var(--gray);
													borderRight: '1px solid #ddd',
													fontWeight: 700,
													background: '#8f8f8f',
												}}>
												<WbSunnyIcon />
												<Box>
													<BodyText one textStyle={{ color: 'white' }}>
														05-12
													</BodyText>
												</Box>
											</Box>
											<Box
												ml={'10px'}
												style={{
													display: 'block',
													padding: '6px 10px',
													textAlign: 'center',
													// font-size: var(--fnt-12);
													// color: var(--gray);
													borderRight: '1px solid #ddd',
													fontWeight: 700,
													background: '#8f8f8f',
												}}>
												<WbSunnyIcon />
												<Box>
													<BodyText one textStyle={{ color: 'white' }}>
														05-12
													</BodyText>
												</Box>
											</Box> */}
										</Box>
									</Grid>
								</Grid>
							</AccordionDetails>
						</Accordion>
					</Box>
					<Grid container style={{ marginTop: 20 }} spacing={2}>
						<Grid item xs={12}>
							<Grid container spacing={4}>
								<Hidden only={['xs', 'sm']}>
									<Grid item xs={3} lg={3}>
										<Box>
											<img src={flightpro} width='100%' height='216px'></img>
										</Box>
									</Grid>
								</Hidden>
								<Grid item xs={12} md={9} lg={9}>
									<Box
										display='flex'
										justifyContent='space-between'
										style={{
											background: '#eee',
											padding: '10px',
											borderBottom: '1px solid #ddd',
											margin: '0 0 15px',
										}}>
										<Box>
											<TitleText one textStyle={{ color: '#666' }}>
												SORT BY
											</TitleText>
										</Box>
										<Box>
											<TitleText one textStyle={{ color: '#666' }}>
												DEPART
											</TitleText>
										</Box>
										<Box>
											<TitleText one textStyle={{ color: '#666' }}>
												DURATION
											</TitleText>
										</Box>

										<Box>
											<TitleText one textStyle={{ color: '#666' }}>
												ARRIVAL
											</TitleText>
										</Box>
										<Box>
											<TitleText one textStyle={{ color: '#666' }}>
												PRICE(Per Adult)
											</TitleText>
										</Box>
									</Box>
									{loading ? (
										[0, 1, 2].map((i) => {
											return (
												<>
													<Box
														display='flex'
														style={{
															boxShadow: '3px 3px 16px -4px rgb(0 0 0 / 30%)',
															padding: 8,
														}}
														justifyContent='space-between'
														mt={'20px'}>
														<Box display='flex' alignItems='center'>
															<Skeleton
																variant='circle'
																width={40}
																height={40}
															/>

															<Box alignItems='center' ml={'5px'}>
																<TitleText two>
																	<Skeleton variant='text' width='60px' />
																</TitleText>

																<Skeleton variant='text' width='60px' />
															</Box>
														</Box>
														{/* <Box
											display='flex'
											justifyContent='space-between'
											alignItems='center'> */}
														<Box>
															<Skeleton variant='text' width='60px' />

															<Skeleton variant='text' width='60px' />
														</Box>
														<Hidden only={['xs']}>
															<Box alignItems='center' textAlign='center'>
																<Skeleton variant='text' width='100px' />

																<Skeleton variant='text' width='60px' />
															</Box>
															<Box>
																<Skeleton variant='text' width='60px' />

																<Skeleton variant='text' width='60px' />
															</Box>
														</Hidden>
														{/* </Box> */}
														<Box alignItems='center' display='flex'>
															<Skeleton
																variant='text'
																width='60px'
																height='30px'
															/>
															<Box style={{ marginLeft: 10 }}></Box>
															{/* <MoreVertIcon /> */}
															<Skeleton
																variant='text'
																width='60px'
																height='60px'
															/>
															<Skeleton
																variant='text'
																width='60px'
																height='60px'
															/>
														</Box>
													</Box>
													<Box
														style={{
															padding: '6px 10px',
															background: '#f5f6f6',
															borderBottomLeftRadius: 4,
															borderBottomRightRadius: 4,
															borderTop: '1px solid #e2e2e2',
															// font-size: var(--fnt-12);
															// color: var(--dark);
														}}
														justifyContent='space-between'
														alignItems='center'
														display='flex'>
														<Box display='flex' alignItems='center'>
															{/* <TitleText>Routes:</TitleText> */}
															<Skeleton
																variant='text'
																width='60px'
																height='40px'
															/>
														</Box>
														<Box
															onClick={() => {
																dispatch(toggleFlightModal(true));
															}}
															display='flex'
															style={{ width: '40%' }}
															justifyContent='space-between'>
															<Box>
																<Skeleton
																	variant='text'
																	width='60px'
																	height='40px'
																/>
															</Box>
															<Box display='flex'>
																<Skeleton
																	variant='text'
																	width='65px'
																	height='40px'
																/>
															</Box>
														</Box>
													</Box>
												</>
											);
										})
									) : result && result.length > 0 ? (
										<InfiniteScroll
											dataLength={scrollValResult}
											next={fetchMoreDataResult}
											hasMore={hasMoreresult}
											loader={<h4>Loading...</h4>}
											endMessage={
												<p style={{ textAlign: 'center' }}>
													<b>No More Data</b>
												</p>
											}>
											{result.map((item, index) => {
												return index < scrollValResult ? (
													matches ? (
														<>
															<Box
																display='flex'
																style={{
																	// boxShadow: '3px 3px 16px -4px rgb(0 0 0 / 30%)',
																	padding: 8,
																}}
																justifyContent='space-between'
																alignItems='center'
																mt={'20px'}>
																<Box display='flex' alignItems='center'>
																	{loading ? (
																		<Skeleton
																			variant='circle'
																			width={40}
																			height={40}
																		/>
																	) : (
																		<img
																			// src={
																			// 	item.Segments[0]
																			// 		.slice(0, 1)
																			// 		.map((i) => {
																			// 			return i.Airline.AirlineName;
																			// 		}) == 'SpiceJet'
																			// 		? spice
																			// 		: item.Segments[0]
																			// 				.slice(0, 1)
																			// 				.map((i) => {
																			// 					return i.Airline.AirlineName;
																			// 				}) == 'Indigo'
																			// 		? indigo
																			// 		: item.Segments[0]
																			// 				.slice(0, 1)
																			// 				.map((i) => {
																			// 					return i.Airline.AirlineName;
																			// 				}) == 'GO FIRST'
																			// 		? go_first
																			// 		: item.Segments[0]
																			// 				.slice(0, 1)
																			// 				.map((i) => {
																			// 					return i.Airline.AirlineName;
																			// 				}) == 'Air India'
																			// 		? air
																			// 		: item.Segments[0]
																			// 				.slice(0, 1)
																			// 				.map((i) => {
																			// 					return i.Airline.AirlineName;
																			// 				}) == 'Air Asia'
																			// 		? airasia
																			// 		: item.Segments[0]
																			// 				.slice(0, 1)
																			// 				.map((i) => {
																			// 					return i.Airline.AirlineName;
																			// 				}) == 'Vistara'
																			// 		? vistara
																			// 		: ''
																			// }
																			width='50px'
																			height='25px'></img>
																	)}

																	<Box alignItems='center' ml={'5px'}>
																		<TitleText
																			two
																			textStyle={{
																				fontFamily: 'Josefin Sans, sans-serif',
																				fontWeight: 500,
																				color: '#3c3c3c',
																			}}>
																			{loading ? (
																				<Skeleton variant='text' width='60px' />
																			) : (
																				item.Segments[0]
																					.slice(0, 1)
																					.map((i) => {
																						return i.Airline.AirlineName;
																					})
																			)}
																		</TitleText>
																		{loading ? (
																			<Skeleton variant='text' width='60px' />
																		) : (
																			<BodyText
																				one
																				textStyle={{
																					fontFamily:
																						'Roboto Serif, sans-serif',
																					color: '#8f8f8f',
																					fontWeight: 600,
																				}}>
																				{item.Segments[0]
																					.slice(0, 1)
																					.map((i) => {
																						return i.Airline.AirlineCode;
																					})}
																				{/* {item.Segments[0].map((i) => {
																					return i.Airline.AirlineCode;
																				})} */}
																				-
																				{item.Segments[0]
																					.slice(0, 1)
																					.map((i) => {
																						return i.Airline.FlightNumber;
																					})}
																				{/* {item.Segments[0].map((i) => {
																					return i.Airline.FlightNumber;
																				})} */}
																			</BodyText>
																		)}
																	</Box>
																</Box>

																<Box alignItems='center' display='flex'>
																	{loading ? (
																		<Skeleton variant='text' width='60px' />
																	) : (
																		<TitleText
																			four
																			textStyle={{
																				fontFamily: 'Josefin Sans, sans-serif',
																				fontWeight: 500,
																			}}>
																			Rs {item.Fare.BaseFare}
																		</TitleText>
																	)}

																	<MoreVertIcon />
																	{loading ? (
																		<Skeleton
																			variant='text'
																			width='60px'
																			height='60px'
																		/>
																	) : (
																		<Box
																			onClick={() => {
																				history.push({
																					pathname: '/flightsummary',
																					state: {
																						OneflightData: item,
																						body: location.state.body,
																						ID:
																							search &&
																							search.data &&
																							search.data.Response &&
																							search.data.Response.TraceId,
																					},
																				});
																			}}
																			style={{
																				color: 'white',
																				background: '#39c9bb',
																				padding: '8px 25px',
																				borderRadius: 8,
																				cursor: 'pointer',
																				fontFamily: 'Josefin Sans, sans-serif',
																				fontWeight: 500,
																				boxShadow:
																					'3px 3px 12px -6px rgb(0 0 0 / 70%)',
																			}}>
																			<TitleText>Book Now</TitleText>
																		</Box>
																	)}
																</Box>
															</Box>
															<Box
																display='flex'
																style={{
																	boxShadow:
																		'3px 3px 16px -4px rgb(0 0 0 / 30%)',
																	padding: 8,
																}}
																justifyContent='space-between'
																alignItems='center'>
																<Box>
																	{loading ? (
																		<Skeleton variant='text' width='60px' />
																	) : (
																		<TitleText
																			two
																			textStyle={{
																				fontFamily: 'Josefin Sans, sans-serif',
																				fontWeight: 500,
																			}}>
																			{item.FareRules[0].Origin}
																		</TitleText>
																	)}
																	{loading ? (
																		<Skeleton variant='text' width='60px' />
																	) : (
																		<TitleText two>
																			{item.Segments[0].slice(0, 1).map((i) => {
																				return i.Origin.DepTime.substr(11, 5);
																			})}
																		</TitleText>
																	)}
																</Box>
																<Box alignItems='center' textAlign='center'>
																	{loading ? (
																		<Skeleton variant='text' width='100px' />
																	) : (
																		<BodyText
																			two
																			textStyle={{
																				color: '#39c9bb',
																				fontWeight: 700,
																			}}>
																			{timeConvert(
																				item.Segments[0].map((i) => {
																					return i.Duration;
																				})
																			)}
																		</BodyText>
																	)}
																	{loading ? (
																		<Skeleton variant='text' width='60px' />
																	) : (
																		<BodyText
																			one
																			textStyle={{ color: '#8f8f8f' }}>
																			Non Stop
																		</BodyText>
																	)}
																</Box>
																<Box>
																	{loading ? (
																		<Skeleton variant='text' width='60px' />
																	) : (
																		<TitleText
																			two
																			textStyle={{
																				fontFamily: 'Josefin Sans, sans-serif',
																				fontWeight: 500,
																			}}>
																			{item.FareRules[0].Destination}
																		</TitleText>
																	)}
																	{loading ? (
																		<Skeleton variant='text' width='60px' />
																	) : (
																		<TitleText two>
																			{item.Segments[0].slice(0, 1).map((i) => {
																				return i.Destination.ArrTime.substr(
																					11,
																					5
																				);
																			})}
																			{/* {item.Segments[0].map((i) => {
																				return i.Destination.ArrTime.substr(
																					11,
																					5
																				);
																			})} */}
																		</TitleText>
																	)}
																</Box>
															</Box>
															<Box
																style={{
																	padding: '6px 10px',
																	background: '#f5f6f6',
																	borderBottomLeftRadius: 4,
																	borderBottomRightRadius: 4,
																	borderTop: '1px solid #e2e2e2',
																}}
																justifyContent='space-between'
																alignItems='center'
																display='flex'>
																<Box display='flex' alignItems='center'>
																	{loading ? (
																		<Skeleton
																			variant='text'
																			width='60px'
																			height='40px'
																		/>
																	) : (
																		<Box
																			style={{
																				padding: '2px 10px',
																				background: '#f56d6d',
																				borderRadius: 4,
																				boxShadow:
																					'3px 3px 12px -6px rgb(0 0 0 / 70%)',
																			}}>
																			<BodyText>{item.ResultFareType}</BodyText>
																		</Box>
																	)}
																</Box>
																<Box
																	onClick={() => {
																		dispatch(toggleFlightModal(true));
																		dispatch(setFlightId(index));
																	}}
																	display='flex'
																	style={{ width: '40%' }}
																	justifyContent='space-between'>
																	<Box>
																		<BodyText
																			two
																			textStyle={{
																				fontFamily: 'Roboto Serif, sans-serif',
																			}}>
																			Free Meals
																		</BodyText>
																	</Box>
																	<Box display='flex' alignItems={'center'}>
																		<BodyText
																			two
																			textStyle={{
																				fontFamily: 'Roboto Serif, sans-serif',
																			}}>
																			Flight Details
																		</BodyText>
																		<ArrowDropDownIcon />
																	</Box>
																</Box>
															</Box>
														</>
													) : (
														<>
															<Box
																display='flex'
																style={{
																	boxShadow:
																		'3px 3px 16px -4px rgb(0 0 0 / 30%)',
																	padding: 8,
																}}
																justifyContent='space-between'
																alignItems='center'
																mt={'20px'}>
																<Box display='flex' alignItems='center'>
																	{loading ? (
																		<Skeleton
																			variant='circle'
																			width={40}
																			height={40}
																		/>
																	) : (
																		<img
																			// src={
																			// 	item.Segments[0]
																			// 		.slice(0, 1)
																			// 		.map((i) => {
																			// 			return i.Airline.AirlineName;
																			// 		}) == 'SpiceJet'
																			// 		? spice
																			// 		: item.Segments[0]
																			// 				.slice(0, 1)
																			// 				.map((i) => {
																			// 					return i.Airline.AirlineName;
																			// 				}) == 'Indigo'
																			// 		? indigo
																			// 		: item.Segments[0]
																			// 				.slice(0, 1)
																			// 				.map((i) => {
																			// 					return i.Airline.AirlineName;
																			// 				}) == 'GO FIRST'
																			// 		? go_first
																			// 		: item.Segments[0]
																			// 				.slice(0, 1)
																			// 				.map((i) => {
																			// 					return i.Airline.AirlineName;
																			// 				}) == 'Air India'
																			// 		? air
																			// 		: item.Segments[0]
																			// 				.slice(0, 1)
																			// 				.map((i) => {
																			// 					return i.Airline.AirlineName;
																			// 				}) == 'Air Asia'
																			// 		? airasia
																			// 		: item.Segments[0]
																			// 				.slice(0, 1)
																			// 				.map((i) => {
																			// 					return i.Airline.AirlineName;
																			// 				}) == 'Vistara'
																			// 		? vistara
																			// 		: ''
																			// }
																			width='50px'
																			height='25px'></img>
																	)}

																	<Box alignItems='center' ml={'5px'}>
																		<TitleText
																			two
																			textStyle={{
																				fontFamily: 'Josefin Sans, sans-serif',
																				fontWeight: 500,
																				color: '#3c3c3c',
																			}}>
																			{loading ? (
																				<Skeleton variant='text' width='60px' />
																			) : (
																				item.Segments[0]
																					.slice(0, 1)
																					.map((i) => {
																						return i.Airline.AirlineName;
																					})
																			)}
																		</TitleText>
																		{loading ? (
																			<Skeleton variant='text' width='60px' />
																		) : (
																			<BodyText
																				one
																				textStyle={{
																					fontFamily:
																						'Roboto Serif, sans-serif',
																					color: '#8f8f8f',
																					fontWeight: 600,
																				}}>
																				{item.Segments[0]
																					.slice(0, 1)
																					.map((i) => {
																						return i.Airline.AirlineCode;
																					})}
																				{/* {item.Segments[0].map((i) => {
																					return i.Airline.AirlineCode;
																				})} */}
																				-
																				{item.Segments[0]
																					.slice(0, 1)
																					.map((i) => {
																						return i.Airline.FlightNumber;
																					})}
																				{/* {item.Segments[0].map((i) => {
																					return i.Airline.FlightNumber;
																				})} */}
																			</BodyText>
																		)}
																	</Box>
																</Box>
																<Box>
																	{loading ? (
																		<Skeleton variant='text' width='60px' />
																	) : (
																		<TitleText
																			two
																			textStyle={{
																				fontFamily: 'Josefin Sans, sans-serif',
																				fontWeight: 500,
																			}}>
																			{item.FareRules[0].Origin}
																		</TitleText>
																	)}
																	{loading ? (
																		<Skeleton variant='text' width='60px' />
																	) : (
																		<TitleText two>
																			{item.Segments[0].slice(0, 1).map((i) => {
																				return i.Origin.DepTime.substr(11, 5);
																			})}
																		</TitleText>
																	)}
																</Box>
																<Box alignItems='center' textAlign='center'>
																	{loading ? (
																		<Skeleton variant='text' width='100px' />
																	) : (
																		<BodyText
																			two
																			textStyle={{
																				color: '#39c9bb',
																				fontWeight: 700,
																			}}>
																			{/* {item.Segments[0].length > 1
																				? Number(
																						item.Segments[0]
																							.filter((i, index) => index === 0)
																							.map((it) => {
																								return it.Duration;
																							}) +
																							item.Segments[0]
																								.filter(
																									(i, index) => index === 1
																								)
																								.map((it) => {
																									return it.Duration;
																								})
																				  )
																				: ''} */}
																			{timeConvert(
																				item.Segments[0].length == 2
																					? Number(
																							item.Segments[0]
																								.filter(
																									(i, index) => index === 0
																								)
																								.map((it) => {
																									return it.Duration;
																								})
																					  ) +
																							Number(
																								item.Segments[0]
																									.filter(
																										(i, index) => index === 1
																									)
																									.map((it) => {
																										return it.Duration;
																									})
																							)
																					: item.Segments[0].length == 1
																					? item.Segments[0].map(
																							(i) => i.Duration
																					  )
																					: item.Segments[0].length == 3
																					? Number(
																							item.Segments[0]
																								.filter(
																									(i, index) => index === 0
																								)
																								.map((it) => {
																									return it.Duration;
																								})
																					  ) +
																					  Number(
																							item.Segments[0]
																								.filter(
																									(i, index) => index === 1
																								)
																								.map((it) => {
																									return it.Duration;
																								})
																					  ) +
																					  Number(
																							item.Segments[0]
																								.filter(
																									(i, index) => index === 2
																								)
																								.map((it) => {
																									return it.Duration;
																								})
																					  )
																					: ''
																			)}
																		</BodyText>
																	)}
																	{loading ? (
																		<Skeleton variant='text' width='60px' />
																	) : (
																		<BodyText
																			one
																			textStyle={{ color: '#8f8f8f' }}>
																			Non Stop
																		</BodyText>
																	)}
																</Box>
																<Box>
																	{loading ? (
																		<Skeleton variant='text' width='60px' />
																	) : (
																		<TitleText
																			two
																			textStyle={{
																				fontFamily: 'Josefin Sans, sans-serif',
																				fontWeight: 500,
																			}}>
																			{item.Segments[0].length == 2
																				? item.Segments[0]
																						.filter((i, index) => index === 1)
																						.map((it) => {
																							return it.Destination.Airport
																								.AirportCode;
																						})
																				: item.Segments[0].length == 3
																				? item.Segments[0]
																						.filter((i, index) => index === 2)
																						.map((it) => {
																							return it.Destination.Airport
																								.AirportCode;
																						})
																				: item.Segments[0].length == 1
																				? item.Segments[0].map((it) => {
																						return it.Destination.Airport
																							.AirportCode;
																				  })
																				: ''}
																		</TitleText>
																	)}
																	{loading ? (
																		<Skeleton variant='text' width='60px' />
																	) : (
																		<TitleText two>
																			{item.Segments[0].length == 3
																				? item.Segments[0]
																						.filter((i, index) => index === 2)
																						.map((i) => {
																							return i.Destination.ArrTime.substr(
																								11,
																								5
																							);
																						})
																				: item.Segments[0].length == 2
																				? item.Segments[0]
																						.filter((i, index) => index === 1)
																						.map((i) => {
																							return i.Destination.ArrTime.substr(
																								11,
																								5
																							);
																						})
																				: item.Segments[0].length == 1
																				? item.Segments[0]
																						.filter((i, index) => index === 0)
																						.map((i) => {
																							return i.Destination.ArrTime.substr(
																								11,
																								5
																							);
																						})
																				: ''}
																		</TitleText>
																	)}
																</Box>
																<Box alignItems='center' display='flex'>
																	{loading ? (
																		<Skeleton variant='text' width='60px' />
																	) : (
																		<TitleText
																			four
																			textStyle={{
																				fontFamily: 'Josefin Sans, sans-serif',
																				fontWeight: 500,
																			}}>
																			Rs {item.Fare.BaseFare}
																		</TitleText>
																	)}

																	<MoreVertIcon />
																	{loading ? (
																		<Skeleton
																			variant='text'
																			width='60px'
																			height='60px'
																		/>
																	) : (
																		<Box
																			onClick={() => {
																				history.push({
																					pathname: '/flightsummary',
																					state: {
																						OneflightData: item,
																						body: location.state.body,
																						ID:
																							search &&
																							search.data &&
																							search.data.Response &&
																							search.data.Response.TraceId,
																					},
																				});
																			}}
																			style={{
																				color: 'white',
																				background: '#39c9bb',
																				padding: '8px 25px',
																				borderRadius: 8,
																				cursor: 'pointer',
																				fontFamily: 'Josefin Sans, sans-serif',
																				fontWeight: 500,
																				boxShadow:
																					'3px 3px 12px -6px rgb(0 0 0 / 70%)',
																			}}>
																			<TitleText>Book Now</TitleText>
																		</Box>
																	)}
																</Box>
															</Box>
															<Box
																style={{
																	padding: '6px 10px',
																	background: '#f5f6f6',
																	borderBottomLeftRadius: 4,
																	borderBottomRightRadius: 4,
																	borderTop: '1px solid #e2e2e2',
																}}
																justifyContent='space-between'
																alignItems='center'
																display='flex'>
																<Box display='flex' alignItems='center'>
																	{loading ? (
																		<Skeleton
																			variant='text'
																			width='60px'
																			height='40px'
																		/>
																	) : (
																		<Box
																			style={{
																				padding: '2px 10px',
																				background: '#f56d6d',
																				borderRadius: 4,
																				boxShadow:
																					'3px 3px 12px -6px rgb(0 0 0 / 70%)',
																			}}>
																			<BodyText>{item.ResultFareType}</BodyText>
																		</Box>
																	)}
																</Box>
																<Box
																	onClick={() => {
																		dispatch(toggleFlightModal(true));
																		dispatch(setFlightId(index));
																	}}
																	display='flex'
																	style={{ width: '40%' }}
																	justifyContent='space-between'>
																	<Box>
																		<BodyText
																			two
																			textStyle={{
																				fontFamily: 'Roboto Serif, sans-serif',
																			}}>
																			Free Meals
																		</BodyText>
																	</Box>
																	<Box display='flex' alignItems={'center'}>
																		<BodyText
																			two
																			textStyle={{
																				fontFamily: 'Roboto Serif, sans-serif',
																			}}>
																			Flight Details
																		</BodyText>
																		<ArrowDropDownIcon />
																	</Box>
																</Box>
															</Box>
														</>
													)
												) : (
													''
												);
											})}
										</InfiniteScroll>
									) : filterData && filterData.length > 0 ? (
										<InfiniteScroll
											dataLength={scrollVal}
											next={fetchMoreData}
											hasMore={hasMorefilterData}
											loader={
												<h4 style={{ textAlign: 'center' }}>Loading...</h4>
											}
											endMessage={
												<p style={{ textAlign: 'center' }}>
													<b>No More Data</b>
												</p>
											}>
											{filterData.map((item, index) => {
												return index < scrollVal ? (
													matches ? (
														<>
															<Box
																display='flex'
																style={{
																	// boxShadow: '3px 3px 16px -4px rgb(0 0 0 / 30%)',
																	padding: 8,
																}}
																justifyContent='space-between'
																alignItems='center'
																mt={'20px'}>
																<Box display='flex' alignItems='center'>
																	{loading ? (
																		<Skeleton
																			variant='circle'
																			width={40}
																			height={40}
																		/>
																	) : (
																		<img
																			// src={
																			// 	item.Segments[0]
																			// 		.slice(0, 1)
																			// 		.map((i) => {
																			// 			return i.Airline.AirlineName;
																			// 		}) == 'SpiceJet'
																			// 		? spice
																			// 		: item.Segments[0]
																			// 				.slice(0, 1)
																			// 				.map((i) => {
																			// 					return i.Airline.AirlineName;
																			// 				}) == 'Indigo'
																			// 		? indigo
																			// 		: item.Segments[0]
																			// 				.slice(0, 1)
																			// 				.map((i) => {
																			// 					return i.Airline.AirlineName;
																			// 				}) == 'GO FIRST'
																			// 		? go_first
																			// 		: item.Segments[0]
																			// 				.slice(0, 1)
																			// 				.map((i) => {
																			// 					return i.Airline.AirlineName;
																			// 				}) == 'Air India'
																			// 		? air
																			// 		: item.Segments[0]
																			// 				.slice(0, 1)
																			// 				.map((i) => {
																			// 					return i.Airline.AirlineName;
																			// 				}) == 'Air Asia'
																			// 		? airasia
																			// 		: item.Segments[0]
																			// 				.slice(0, 1)
																			// 				.map((i) => {
																			// 					return i.Airline.AirlineName;
																			// 				}) == 'Vistara'
																			// 		? vistara
																			// 		: ''
																			// }
																			width='50px'
																			height='25px'></img>
																	)}

																	<Box alignItems='center' ml={'5px'}>
																		<TitleText
																			two={matches ? false : true}
																			textStyle={{
																				fontFamily: 'Josefin Sans, sans-serif',
																				fontWeight: 500,
																				color: '#3c3c3c',
																				fontSize: matches ? 12 : '',
																			}}>
																			{loading ? (
																				<Skeleton variant='text' width='60px' />
																			) : (
																				item.Segments[0]
																					.slice(0, 1)
																					.map((i) => {
																						return i.Airline.AirlineName;
																					})
																			)}
																		</TitleText>
																		{loading ? (
																			<Skeleton variant='text' width='60px' />
																		) : (
																			<BodyText
																				one
																				textStyle={{
																					fontFamily:
																						'Roboto Serif, sans-serif',
																					color: '#8f8f8f',
																					fontWeight: 600,
																				}}>
																				{item.Segments[0]
																					.slice(0, 1)
																					.map((i) => {
																						return i.Airline.AirlineCode;
																					})}
																				{/* {item.Segments[0].map((i) => {
																					return i.Airline.AirlineCode;
																				})} */}
																				-
																				{item.Segments[0]
																					.slice(0, 1)
																					.map((i) => {
																						return i.Airline.FlightNumber;
																					})}
																				{/* {item.Segments[0].map((i) => {
																					return i.Airline.FlightNumber;
																				})} */}
																			</BodyText>
																		)}
																	</Box>
																</Box>

																<Box alignItems='center' display='flex'>
																	{loading ? (
																		<Skeleton variant='text' width='60px' />
																	) : (
																		<TitleText
																			four={matches ? false : true}
																			textStyle={{
																				fontFamily: 'Josefin Sans, sans-serif',
																				fontWeight: 500,
																				fontSize: matches ? 14 : '',
																			}}>
																			Rs {item.Fare.BaseFare}
																		</TitleText>
																	)}

																	<MoreVertIcon />
																	{loading ? (
																		<Skeleton
																			variant='text'
																			width='60px'
																			height='60px'
																		/>
																	) : (
																		<Box
																			onClick={() => {
																				history.push({
																					pathname: '/flightsummary',
																					state: {
																						OneflightData: item,
																						body: location.state.body,
																						ID:
																							search &&
																							search.data &&
																							search.data.Response &&
																							search.data.Response.TraceId,
																					},
																				});
																			}}
																			style={{
																				color: 'white',
																				background: '#39c9bb',
																				padding: '8px 25px',
																				borderRadius: 8,
																				cursor: 'pointer',
																				fontFamily: 'Josefin Sans, sans-serif',
																				fontWeight: 500,
																				boxShadow:
																					'3px 3px 12px -6px rgb(0 0 0 / 70%)',
																			}}>
																			<TitleText
																				textStyle={{
																					fontSize: matches ? 14 : '',
																				}}>
																				Book Now
																			</TitleText>
																		</Box>
																	)}
																</Box>
															</Box>
															<Box
																display='flex'
																style={{
																	boxShadow:
																		'3px 3px 16px -4px rgb(0 0 0 / 30%)',
																	padding: 8,
																}}
																justifyContent='space-between'
																alignItems='center'>
																<Box>
																	{loading ? (
																		<Skeleton variant='text' width='60px' />
																	) : (
																		<TitleText
																			two
																			textStyle={{
																				fontFamily: 'Josefin Sans, sans-serif',
																				fontWeight: 500,
																			}}>
																			{item.FareRules[0].Origin}
																		</TitleText>
																	)}
																	{loading ? (
																		<Skeleton variant='text' width='60px' />
																	) : (
																		<TitleText two>
																			{item.Segments[0].slice(0, 1).map((i) => {
																				return i.Origin.DepTime.substr(11, 5);
																			})}
																		</TitleText>
																	)}
																</Box>
																<Box alignItems='center' textAlign='center'>
																	{loading ? (
																		<Skeleton variant='text' width='100px' />
																	) : (
																		<BodyText
																			two
																			textStyle={{
																				color: '#39c9bb',
																				fontWeight: 700,
																			}}>
																			{timeConvert(
																				item.Segments[0].map((i) => {
																					return i.Duration;
																				})
																			)}
																		</BodyText>
																	)}
																	{loading ? (
																		<Skeleton variant='text' width='60px' />
																	) : (
																		<BodyText
																			one
																			textStyle={{ color: '#8f8f8f' }}>
																			Non Stop
																		</BodyText>
																	)}
																</Box>
																<Box>
																	{loading ? (
																		<Skeleton variant='text' width='60px' />
																	) : (
																		<TitleText
																			two
																			textStyle={{
																				fontFamily: 'Josefin Sans, sans-serif',
																				fontWeight: 500,
																			}}>
																			{item.FareRules[0].Destination}
																		</TitleText>
																	)}
																	{loading ? (
																		<Skeleton variant='text' width='60px' />
																	) : (
																		<TitleText two>
																			{item.Segments[0].slice(0, 1).map((i) => {
																				return i.Destination.ArrTime.substr(
																					11,
																					5
																				);
																			})}
																		</TitleText>
																	)}
																</Box>
															</Box>
															<Box
																style={{
																	padding: '6px 10px',
																	background: '#f5f6f6',
																	borderBottomLeftRadius: 4,
																	borderBottomRightRadius: 4,
																	borderTop: '1px solid #e2e2e2',
																}}
																justifyContent='space-between'
																alignItems='center'
																display='flex'>
																<Box display='flex' alignItems='center'>
																	{loading ? (
																		<Skeleton
																			variant='text'
																			width='60px'
																			height='40px'
																		/>
																	) : (
																		<Box
																			style={{
																				padding: '2px 10px',
																				background: '#f56d6d',
																				borderRadius: 4,
																				boxShadow:
																					'3px 3px 12px -6px rgb(0 0 0 / 70%)',
																			}}>
																			<BodyText>{item.ResultFareType}</BodyText>
																		</Box>
																	)}
																</Box>
																<Box
																	onClick={() => {
																		dispatch(toggleFlightModal(true));
																		dispatch(setFlightId(index));
																	}}
																	display='flex'
																	style={{ width: '40%' }}
																	justifyContent='space-between'>
																	<Box>
																		<BodyText
																			two
																			textStyle={{
																				fontFamily: 'Roboto Serif, sans-serif',
																			}}>
																			Free Meals
																		</BodyText>
																	</Box>
																	<Box display='flex' alignItems={'center'}>
																		<BodyText
																			two
																			textStyle={{
																				fontFamily: 'Roboto Serif, sans-serif',
																			}}>
																			Flight Details
																		</BodyText>
																		<ArrowDropDownIcon />
																	</Box>
																</Box>
															</Box>
														</>
													) : (
														<>
															<Box
																display='flex'
																style={{
																	boxShadow:
																		'3px 3px 16px -4px rgb(0 0 0 / 30%)',
																	padding: 8,
																}}
																justifyContent='space-between'
																alignItems='center'
																mt={'20px'}>
																<Box display='flex' alignItems='center'>
																	{loading ? (
																		<Skeleton
																			variant='circle'
																			width={40}
																			height={40}
																		/>
																	) : (
																		<img
																			// src={
																			// 	item.Segments[0]
																			// 		.slice(0, 1)
																			// 		.map((i) => {
																			// 			return i.Airline.AirlineName;
																			// 		}) == 'SpiceJet'
																			// 		? spice
																			// 		: item.Segments[0]
																			// 				.slice(0, 1)
																			// 				.map((i) => {
																			// 					return i.Airline.AirlineName;
																			// 				}) == 'Indigo'
																			// 		? indigo
																			// 		: item.Segments[0]
																			// 				.slice(0, 1)
																			// 				.map((i) => {
																			// 					return i.Airline.AirlineName;
																			// 				}) == 'GO FIRST'
																			// 		? go_first
																			// 		: item.Segments[0]
																			// 				.slice(0, 1)
																			// 				.map((i) => {
																			// 					return i.Airline.AirlineName;
																			// 				}) == 'Air India'
																			// 		? air
																			// 		: item.Segments[0]
																			// 				.slice(0, 1)
																			// 				.map((i) => {
																			// 					return i.Airline.AirlineName;
																			// 				}) == 'Air Asia'
																			// 		? airasia
																			// 		: item.Segments[0]
																			// 				.slice(0, 1)
																			// 				.map((i) => {
																			// 					return i.Airline.AirlineName;
																			// 				}) == 'Vistara'
																			// 		? vistara
																			// 		: ''
																			// }
																			width='50px'
																			height='25px'></img>
																	)}

																	<Box alignItems='center' ml={'5px'}>
																		<TitleText
																			two
																			textStyle={{
																				fontFamily: 'Josefin Sans, sans-serif',
																				fontWeight: 500,
																				color: '#3c3c3c',
																			}}>
																			{loading ? (
																				<Skeleton variant='text' width='60px' />
																			) : (
																				item.Segments[0]
																					.slice(0, 1)
																					.map((i) => {
																						return i.Airline.AirlineName;
																					})
																			)}
																		</TitleText>
																		{loading ? (
																			<Skeleton variant='text' width='60px' />
																		) : (
																			<BodyText
																				one
																				textStyle={{
																					fontFamily:
																						'Roboto Serif, sans-serif',
																					color: '#8f8f8f',
																					fontWeight: 600,
																				}}>
																				{item.Segments[0]
																					.slice(0, 1)
																					.map((i) => {
																						return i.Airline.AirlineCode;
																					})}
																				{/* {item.Segments[0].map((i) => {
																					return i.Airline.AirlineCode;
																				})} */}
																				-
																				{item.Segments[0]
																					.slice(0, 1)
																					.map((i) => {
																						return i.Airline.FlightNumber;
																					})}
																				{/* {item.Segments[0].map((i) => {
																					return i.Airline.FlightNumber;
																				})} */}
																			</BodyText>
																		)}
																	</Box>
																</Box>
																<Box>
																	{loading ? (
																		<Skeleton variant='text' width='60px' />
																	) : (
																		<TitleText
																			two
																			textStyle={{
																				fontFamily: 'Josefin Sans, sans-serif',
																				fontWeight: 500,
																			}}>
																			{item.FareRules[0].Origin}
																		</TitleText>
																	)}
																	{loading ? (
																		<Skeleton variant='text' width='60px' />
																	) : (
																		<TitleText two>
																			{item.Segments[0].slice(0, 1).map((i) => {
																				return i.Origin.DepTime.substr(11, 5);
																			})}
																			{console.log(
																				item.Segments[0]
																					.slice(0, 1)
																					.map((i) => {
																						return i.Origin.DepTime.substr(
																							11,
																							2
																						);
																					}) > 2
																					? 'YES'
																					: 'NO'
																			)}
																		</TitleText>
																	)}
																</Box>
																<Box alignItems='center' textAlign='center'>
																	{loading ? (
																		<Skeleton variant='text' width='100px' />
																	) : (
																		<BodyText
																			two
																			textStyle={{
																				color: '#39c9bb',
																				fontWeight: 700,
																			}}>
																			{timeConvert(
																				item.Segments[0].length == 2
																					? Number(
																							item.Segments[0]
																								.filter(
																									(i, index) => index === 0
																								)
																								.map((it) => {
																									return it.Duration;
																								})
																					  ) +
																							Number(
																								item.Segments[0]
																									.filter(
																										(i, index) => index === 1
																									)
																									.map((it) => {
																										return it.Duration;
																									})
																							)
																					: item.Segments[0].length == 1
																					? item.Segments[0].map(
																							(i) => i.Duration
																					  )
																					: item.Segments[0].length == 3
																					? Number(
																							item.Segments[0]
																								.filter(
																									(i, index) => index === 0
																								)
																								.map((it) => {
																									return it.Duration;
																								})
																					  ) +
																					  Number(
																							item.Segments[0]
																								.filter(
																									(i, index) => index === 1
																								)
																								.map((it) => {
																									return it.Duration;
																								})
																					  ) +
																					  Number(
																							item.Segments[0]
																								.filter(
																									(i, index) => index === 2
																								)
																								.map((it) => {
																									return it.Duration;
																								})
																					  )
																					: ''
																			)}
																		</BodyText>
																	)}
																	{loading ? (
																		<Skeleton variant='text' width='60px' />
																	) : (
																		<BodyText
																			one
																			textStyle={{ color: '#8f8f8f' }}>
																			Non Stop
																		</BodyText>
																	)}
																</Box>
																<Box>
																	{loading ? (
																		<Skeleton variant='text' width='60px' />
																	) : (
																		<TitleText
																			two
																			textStyle={{
																				fontFamily: 'Josefin Sans, sans-serif',
																				fontWeight: 500,
																			}}>
																			{item.Segments[0].length == 2
																				? item.Segments[0]
																						.filter((i, index) => index === 1)
																						.map((it) => {
																							return it.Destination.Airport
																								.AirportCode;
																						})
																				: item.Segments[0].length == 3
																				? item.Segments[0]
																						.filter((i, index) => index === 2)
																						.map((it) => {
																							return it.Destination.Airport
																								.AirportCode;
																						})
																				: item.Segments[0].length == 1
																				? item.Segments[0].map((it) => {
																						return it.Destination.Airport
																							.AirportCode;
																				  })
																				: ''}
																		</TitleText>
																	)}
																	{loading ? (
																		<Skeleton variant='text' width='60px' />
																	) : (
																		<TitleText two>
																			{item.Segments[0].length == 3
																				? item.Segments[0]
																						.filter((i, index) => index === 2)
																						.map((i) => {
																							return i.Destination.ArrTime.substr(
																								11,
																								5
																							);
																						})
																				: item.Segments[0].length == 2
																				? item.Segments[0]
																						.filter((i, index) => index === 1)
																						.map((i) => {
																							return i.Destination.ArrTime.substr(
																								11,
																								5
																							);
																						})
																				: item.Segments[0].length == 1
																				? item.Segments[0]
																						.filter((i, index) => index === 0)
																						.map((i) => {
																							return i.Destination.ArrTime.substr(
																								11,
																								5
																							);
																						})
																				: ''}
																		</TitleText>
																	)}
																</Box>
																<Box alignItems='center' display='flex'>
																	{loading ? (
																		<Skeleton variant='text' width='60px' />
																	) : (
																		<TitleText
																			four
																			textStyle={{
																				fontFamily: 'Josefin Sans, sans-serif',
																				fontWeight: 500,
																			}}>
																			Rs {item.Fare.BaseFare}
																		</TitleText>
																	)}

																	<MoreVertIcon />
																	{loading ? (
																		<Skeleton
																			variant='text'
																			width='60px'
																			height='60px'
																		/>
																	) : (
																		<Box
																			onClick={() => {
																				history.push({
																					pathname: '/flightsummary',
																					state: {
																						OneflightData: item,
																						body: location.state.body,
																						ID:
																							search &&
																							search.data &&
																							search.data.Response &&
																							search.data.Response.TraceId,
																					},
																				});
																			}}
																			style={{
																				color: 'white',
																				background: '#39c9bb',
																				padding: '8px 25px',
																				borderRadius: 8,
																				cursor: 'pointer',
																				fontFamily: 'Josefin Sans, sans-serif',
																				fontWeight: 500,
																				boxShadow:
																					'3px 3px 12px -6px rgb(0 0 0 / 70%)',
																			}}>
																			<TitleText>Book Now</TitleText>
																		</Box>
																	)}
																</Box>
															</Box>
															<Box
																style={{
																	padding: '6px 10px',
																	background: '#f5f6f6',
																	borderBottomLeftRadius: 4,
																	borderBottomRightRadius: 4,
																	borderTop: '1px solid #e2e2e2',
																}}
																justifyContent='space-between'
																alignItems='center'
																display='flex'>
																<Box display='flex' alignItems='center'>
																	{loading ? (
																		<Skeleton
																			variant='text'
																			width='60px'
																			height='40px'
																		/>
																	) : (
																		<Box
																			style={{
																				padding: '2px 10px',
																				background: '#f56d6d',
																				borderRadius: 4,
																				boxShadow:
																					'3px 3px 12px -6px rgb(0 0 0 / 70%)',
																			}}>
																			<BodyText>{item.ResultFareType}</BodyText>
																		</Box>
																	)}
																</Box>
																<Box
																	onClick={() => {
																		dispatch(toggleFlightModal(true));
																		dispatch(setFlightId(index));
																	}}
																	display='flex'
																	style={{ width: '40%' }}
																	justifyContent='space-between'>
																	<Box>
																		<BodyText
																			two
																			textStyle={{
																				fontFamily: 'Roboto Serif, sans-serif',
																			}}>
																			Free Meals
																		</BodyText>
																	</Box>
																	<Box display='flex' alignItems={'center'}>
																		<BodyText
																			two
																			textStyle={{
																				fontFamily: 'Roboto Serif, sans-serif',
																			}}>
																			Flight Details
																		</BodyText>
																		<ArrowDropDownIcon />
																	</Box>
																</Box>
															</Box>
														</>
													)
												) : (
													''
												);
											})}
										</InfiniteScroll>
									) : (
										search &&
										search.data &&
										search.data.Response &&
										search.data.Response.Results &&
										search.data.Response.Results[0].length > 0 &&
										search.data.Response.Results[0].map((item, index) => {
											return (
												<>
													<Box
														display='flex'
														style={{
															boxShadow: '3px 3px 16px -4px rgb(0 0 0 / 30%)',
															padding: 8,
														}}
														justifyContent='space-between'
														mt={'20px'}>
														<Box display='flex' alignItems='center'>
															<img
																// src={
																// 	item.Segments[0].slice(0, 1).map((i) => {
																// 		return i.Airline.AirlineName;
																// 	}) == 'SpiceJet'
																// 		? spice
																// 		: item.Segments[0].slice(0, 1).map((i) => {
																// 				return i.Airline.AirlineName;
																// 		  }) == 'Indigo'
																// 		? indigo
																// 		: item.Segments[0].slice(0, 1).map((i) => {
																// 				return i.Airline.AirlineName;
																// 		  }) == 'GO FIRST'
																// 		? go_first
																// 		: item.Segments[0].slice(0, 1).map((i) => {
																// 				return i.Airline.AirlineName;
																// 		  }) == 'Air India'
																// 		? air
																// 		: item.Segments[0].slice(0, 1).map((i) => {
																// 				return i.Airline.AirlineName;
																// 		  }) == 'Air Asia'
																// 		? airasia
																// 		: item.Segments[0].slice(0, 1).map((i) => {
																// 				return i.Airline.AirlineName;
																// 		  }) == 'Vistara'
																// 		? vistara
																// 		: ''
																// }
																width='50px'
																height='25px'></img>
															<Box alignItems='center' ml={'5px'}>
																<TitleText two>
																	{item.Segments[0].map((i) => {
																		return i.Airline.AirlineName;
																	})}
																</TitleText>
																<BodyText two>
																	{item.Segments[0].slice(0, 1).map((i) => {
																		return i.Airline.AirlineCode;
																	})}
																	{/* {item.Segments[0].map((i) => {
																					return i.Airline.AirlineCode;
																				})} */}
																	-
																	{item.Segments[0].slice(0, 1).map((i) => {
																		return i.Airline.FlightNumber;
																	})}
																	{/* {item.Segments[0].map((i) => {
																					return i.Airline.FlightNumber;
																				})} */}
																</BodyText>
															</Box>
														</Box>
														{/* <Box
											display='flex'
											justifyContent='space-between'
											alignItems='center'> */}
														<Box>
															<TitleText two>
																{item.FareRules[0].Origin}
															</TitleText>
															<TitleText two>
																{item.Segments[0].slice(0, 1).map((i) => {
																	return i.Origin.DepTime.substr(11, 5);
																})}
																{/* {item.Segments[0].map((i) => {
																	return i.Origin.DepTime.substr(11, 5);
																})} */}
															</TitleText>
														</Box>
														<Box alignItems='center' textAlign='center'>
															<TitleText two>
																{console.log(item.Segments[0].slice(0, 2))}
																{/* {timeConvert(
																	item.Segments[0].map((i) => {
																		return i.Duration;
																	})
																)}
																{timeConvert(
																	item.Segments[0].length > 1 ? item.Segments[0].slice(0, 2).map((i) => {
																		
																	}).map((i) => {
																		return i.Duration;
																	})
																)} */}
															</TitleText>
															<TitleText one>Non Stop</TitleText>
														</Box>
														<Box>
															<TitleText two>
																{item.FareRules[0].Destination}
															</TitleText>
															<TitleText two>
																{item.Segments[0].slice(0, 1).map((i) => {
																	return i.Destination.ArrTime.substr(11, 5);
																})}
															</TitleText>
														</Box>
														{/* </Box> */}
														<Box alignItems='center' display='flex'>
															<TitleText>Rs {item.Fare.BaseFare}</TitleText>
															<MoreVertIcon />
															<Box
																onClick={() => {
																	history.push({
																		pathname: '/flightsummary',
																		state: {
																			OneflightData: item,
																			body: location.state.body,
																		},
																	});
																}}
																style={{
																	color: 'white',
																	background: '#39c9bb',
																	padding: '8px 25px',
																	borderRadius: 8,
																	boxShadow:
																		'3px 3px 12px -6px rgb(0 0 0 / 70%)',
																}}>
																<TitleText>Book Now</TitleText>
															</Box>
														</Box>
													</Box>
													<Box
														style={{
															padding: '6px 10px',
															background: '#f5f6f6',
															borderBottomLeftRadius: 4,
															borderBottomRightRadius: 4,
															borderTop: '1px solid #e2e2e2',
															// font-size: var(--fnt-12);
															// color: var(--dark);
														}}
														justifyContent='space-between'
														alignItems='center'
														display='flex'>
														<Box display='flex' alignItems='center'>
															<TitleText>Routes:</TitleText>
															<Box
																style={{
																	padding: '2px 10px',
																	// margin: 0 5px;
																	background: '#f56d6d',
																	borderRadius: 4,
																	boxShadow:
																		'3px 3px 12px -6px rgb(0 0 0 / 70%)',
																}}>
																<BodyText>{item.ResultFareType}</BodyText>
															</Box>
														</Box>
														<Box
															onClick={() => {
																dispatch(toggleFlightModal(true));
																dispatch(setFlightId(index));
															}}
															// onClick={() => { dispatch(toggleFlightModal(true)); dispatch(setFlightId(index));}
															display='flex'
															style={{ width: '40%' }}
															justifyContent='space-between'>
															{/* <Box>
																	<BodyText two>Free Meals</BodyText>
																</Box> */}
															<Box display='flex'>
																<TitleText two>Flight Details</TitleText>
																<ArrowDropDownIcon />
															</Box>
														</Box>
													</Box>
												</>
											);
										})
									)}
									{/* {[0, 1, 2, 3, 4, 5].map((item) => {
										return (
											
										);
									})} */}
								</Grid>
							</Grid>
						</Grid>
					</Grid>
				</Container>
			</Box>
			<FlightDetailModal />
			<Drawers />
			<Login />
		</>
	);
};

export default Flight;
